<script lang="ts">
  import Banner from '$icons/RankingBannerIcon.svelte';
  import Rank_1Icon from '$icons/Rank1Icon.svelte';
  import Rank_2Icon from '$icons/Rank2Icon.svelte';
  import Rank_3Icon from '$icons/Rank3Icon.svelte';

  export let value: number = null;
  export let slot: boolean = false;
</script>

<div class="relative inline-block">
  <div>
    <Banner />
  </div>

  <div
    class="
				absolute top-0 w-[52.5px] h-[55px]
				flex items-center justify-center
				text-center text-white"
  >
    {#if value == 1}
      <Rank_1Icon />
    {:else if value == 2}
      <Rank_2Icon />
    {:else if value == 3}
      <Rank_3Icon />
    {:else if slot}
      <slot />
    {:else}
      {value}
    {/if}
  </div>
</div>
